<template>
  <tippy
    :append-to="documentBody"
    :content-class="`ai-tooltip__info ${contentClass}`"
    :placement="location"
    interactive
  >
    <span class="ai-tooltip__text" v-if="tooltipText">{{ tooltipText }}</span>
    <slot v-if="top" name="top" />
    <inline-svg v-if="!tooltipText && !top" :src="require('@/assets/icons/IconQuestionMark.svg')" />
    <template #content>
      <slot name="content" />
    </template>
  </tippy>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { Tippy } from 'vue-tippy';
import 'tippy.js/dist/tippy.css';

defineProps<{
  location: 'bottom' | 'top' | 'left' | 'right';
  tooltipText?: string;
  contentClass?: string;
  top?: boolean;
}>();

const documentBody = computed(() => document.body);
</script>

<style lang="scss" src="./AiTooltip.scss" />
